export const DATE_MASK = '__.__.____'
export const UNDERDASH = '_'
export const SEPARATOR = '.'
export const SEPARATOR_POSITIONS = [3, 6]
export const DATE_PARTS_COUNT = 3
export const YEAR_INDEX = 2
export const YEAR_STR_LENGTH = 4
export const DAY_AND_MONTH_STR_LENGTH = 2

export const ONLY_NUMBERS_REGEX = new RegExp('\\d+', 'g')
export const NUMBERS_AND_MASK_SYMBOLS_REGEX = new RegExp('^(\\d|\\.|_)+$')
export const GLUED_DATE_STRING_REGEX = new RegExp(
  '(\\d{0,2})(\\d{0,2})(\\d{0,4})',
  'g'
)
